import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

export const ManageLink = styled("div")(({ theme }: { theme: Theme }) => ({
  fontSize: 13,
  color: theme.palette.brand.gray500,
  "& a": {
    color: theme.palette.brand.coral,
    textDecoration: "none",
    fontWeight: 500,
    "&:hover": { textDecoration: "underline" },
  },
}));
